<template>
  <g v-for="tile in tiles" :key="tile.url" class="wmts-tile">
    <image
      :href="tile.url"
      :x="tile.x"
      :y="-tile.y"
      :width="tile.width"
      :height="tile.height" />

    <template v-if="debugTiles">
      <rect z="10000" :x="tile.x" :y="-tile.y" :width="tile.width" :height="tile.height" fill="none" stroke="red" stroke-width="20" />
      <text z="10001" :x="tile.x + 100" :y="-tile.y + 300">{{ tile.col }}, {{ tile.row }}</text>
      <text z="10001" :x="tile.x + 100" :y="-tile.y + 600">{{ Math.round(tile.x) }}, {{ Math.round(tile.y) }}</text>
    </template>

  </g>
</template>

<script setup>
  import { ref, computed, onMounted, watch } from "vue";
  import { useWmtsStore } from "../../stores/wmts-channel";
  import { logger } from "../../services/logger";

  const viewbox = defineModel("viewbox");
  const layers = defineModel("layers");
  const layer = defineModel("layer");
  const zooms = defineModel("zooms");
  const zoom = defineModel("zoom");
  const tiles = ref([]);
  const debugTiles = ref(false)
  const wmts = useWmtsStore();
  wmts.layers(l => {
    layers.value = l;
    layer.value = l.find(l => l.default)?.identifier;
  });
  wmts.zooms(z => {
    zooms.value = z;
    zoom.value = z.find(z => z.default)?.zoom;
  });

  watch(() => viewbox.value, update);
  watch(() => layer.value, update);
  watch(() => zoom.value, update);
  onMounted(update);

  async function update() {
    if (!viewbox.value) return;
    logger.debug("Wmts.vue: update", { viewbox: viewbox.value, layer: layer.value, zoom: zoom.value });
    wmts.tiles(viewbox.value, layer.value, zoom.value, (fetchedTiles, data) => {
      tiles.value = fetchedTiles;
    });
  }
</script>

<style scoped>
  .wmts-tile text {
    font-size: 200px;
    fill: red;
  }
</style>